export const MAX_IMAGE_BYTES = 10 * 1024 * 1024;

// A lightweight signature check, not a complete image decoder or security scan.
export function matchesImageSignature(bytes, mimeType) {
  if (mimeType === 'image/png') {
    return bytes.length >= 8 && [137, 80, 78, 71, 13, 10, 26, 10].every((value, index) => bytes[index] === value);
  }
  if (mimeType === 'image/jpeg') {
    return bytes.length >= 3 && bytes[0] === 255 && bytes[1] === 216 && bytes[2] === 255;
  }
  if (mimeType === 'image/webp') {
    return bytes.length >= 12 && [82, 73, 70, 70].every((value, index) => bytes[index] === value)
      && [87, 69, 66, 80].every((value, index) => bytes[index + 8] === value);
  }
  return false;
}
